import { FaLeaf, FaPaintRoller, FaShieldAlt, FaHardHat } from 'react-icons/fa';

const features = [
  {
    id: 1,
    icon: <FaLeaf />, // Energy Efficiency icon
    title: 'Energy Efficiency',
    description: 'Offering windows and doors with superior energy-saving features',
  },
  {
    id: 2,
    icon: <FaPaintRoller />, // Custom Designs icon
    title: 'Custom Designs',
    description: "Providing tailored solutions to match your home's unique style",
  },
  {
    id: 3,
    icon: <FaShieldAlt />, // Security Enhancements icon
    title: 'Security Enhancements',
    description: 'Integrating advanced security features for peace of mind',
  },
  {
    id: 4,
    icon: <FaHardHat />, // Durability icon
    title: 'Durability',
    description: 'Ensuring long-lasting performance and resilience against the elements',
  },
];

export default features;